import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar as MuiSnackbar, IconButton, Alert } from '@mui/material';
import { Close } from '@mui/icons-material';

const Props = {
  open: PropTypes.bool,
  message: PropTypes.string,
  severity: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default function Snackbar({ open, message, severity, onClose }) {
  function handleClose(event, reason) {
    if (reason !== 'clickaway') {
      onClose();
    }
  }

  return (
    <MuiSnackbar
      open={open !== undefined ? open : !!message}
      autoHideDuration={6000}
      onClose={handleClose}
      message={message}
      action={
        <IconButton size="small" color="inherit" onClick={handleClose}>
          <Close fontSize="small" />
        </IconButton>
      }
    >
      {!!severity && (
        <Alert
          severity={severity}
          elevation={6}
          variant="filled"
          icon={false}
          onClose={handleClose}
        >
          {message}
        </Alert>
      )}
    </MuiSnackbar>
  );
}

Snackbar.propTypes = Props;
